import {Card, CardContent, styled} from '@mui/material'
import {Texts} from 'appearance'
import {dashboardStatuses} from 'constants/dashboard'
import {useDeviceDetect} from 'services/hooks'
import {useI18n} from 'store/Store'

const RequestsStatus = ({data, selectedStatus, onSelectStatus}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    return (
        <Container>
            {dashboardStatuses.map((status) => (
                <StyledCard
                    key={status}
                    variant="outlined"
                    style={{flex: 1}}
                    onClick={() => onSelectStatus(status)}>
                    <StyledCardContent>
                        <RequestsCount>{data[status]}</RequestsCount>
                        <StatusTitle>
                            {i18n.t(`dashboard.${status}`)}
                        </StatusTitle>
                    </StyledCardContent>
                </StyledCard>
            ))}
            {!isMobile && (
                <StyledCard
                    key={'next-payment'}
                    variant="outlined"
                    style={{flex: 1}}>
                    <StyledCardContent>
                        <RequestsCount>{`${data.paymentTotal} ₪`}</RequestsCount>
                        <StatusTitle>
                            {i18n.t(`dashboard.nextPayment`)}
                        </StatusTitle>
                    </StyledCardContent>
                </StyledCard>
            )}
        </Container>
    )
}

export default RequestsStatus

const Container = styled('div')`
    display: flex;
    justify-content: space-between;
    /* gap: 10%; */
    gap: 20px;
`
const StyledCard = styled(Card)`
    border-radius: 2px;
`

const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const RequestsCount = styled(Texts.BoldText)`
    font-size: 26px;
`

const StatusTitle = styled(Texts.RegularText)`
    font-size: 20px;
`
